/** Mirrors Training/Model/TopicKind.cs (serialized by name). Append-only: never rename or reorder a kind. */
export type TopicKind = "Theory" | "Practical";

export const TOPIC_KINDS: TopicKind[] = ["Theory", "Practical"];
